import React from 'react';
import { Route } from 'react-router-dom';
import Agreement from 'components/Terms/Agreement';

const routes = [
  <Route key="toc" path="/terms-and-conditions" exact><Agreement/></Route>
];

export default routes;
